import React from 'react';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import HoneycombQuestLogo from "../../images/honeycombQuest.png";

const Offline = () => {
  const offlineArea = css`
    color: #555555;

    text-align: center;
    height: ${window.innerHeight}px;
    width: 100vw;
    margin-top: 120px;
    .honeycomb-quest-logo {
      width: 200px;
    }
    div {
      margin-top: 50px;
    }

  `;


  return (
    <>
      <div css={offlineArea}>
        <img src={HoneycombQuestLogo} alt="" className='honeycomb-quest-logo' />
        <div>
          現在オフラインです。<br />
          お手数ですが、インターネット接続を再度ご確認ください。<br /><br /><br /><br />


          <a href="/">リロード</a>
        </div>
      </div>
    </>
  )
}

export default Offline
